import script from "./RecordsTask.vue?vue&type=script&setup=true&lang=js"
export * from "./RecordsTask.vue?vue&type=script&setup=true&lang=js"

import "@/assets/common.css?vue&type=style&index=0&lang=css&external"
import "./RecordsTask.vue?vue&type=style&index=1&id=794a9026&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-794a9026"]])

export default __exports__